import styled from "styled-components"

const Flex = styled.div`
  align-items: ${(props) => props.alignItems};
  display: flex;
  justify-content: ${(props) => props.justifyContent};
  width: ${(props) => props.block && "100%"};
`

Flex.defaultProps = {
  alignItems: "center",
  justifyContent: "flex-start",
}

export {Flex}
